<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

// Counts up to `to` when scrolled into view (cubic ease-out). Honours
// prefers-reduced-motion by snapping straight to the value.
const props = defineProps({
  to: { type: Number, required: true },
  suffix: { type: String, default: '' },
  duration: { type: Number, default: 1700 },
});

const el = ref(null);
const n = ref(0);
let raf = null;
let io = null;

onMounted(() => {
  const node = el.value;
  if (!node) return;
  let done = false;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  io = new IntersectionObserver(
    (entries) => entries.forEach((e) => {
      if (e.isIntersecting && !done) {
        done = true;
        if (reduce) { n.value = props.to; return; }
        const start = performance.now();
        const tick = (now) => {
          const t = Math.min(1, (now - start) / props.duration);
          n.value = props.to * (1 - Math.pow(1 - t, 3));
          if (t < 1) raf = requestAnimationFrame(tick);
          else n.value = props.to;
        };
        raf = requestAnimationFrame(tick);
      }
    }),
    { threshold: 0.5 }
  );
  io.observe(node);
});

onUnmounted(() => {
  if (io) io.disconnect();
  if (raf) cancelAnimationFrame(raf);
});
</script>

<template>
  <span ref="el" class="gm-stat__value gm-stat__value--gold">{{ Math.round(n).toLocaleString() }}{{ suffix }}</span>
</template>
